
import { Building, Home } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { UseFormReturn } from "react-hook-form";
import { ListingFormValues } from "@/components/listings/filters/FilterSchema";
import PlotDetailsSection from "./sections/PlotDetailsSection";
import RoomsSection from "./sections/RoomsSection";
import PropertyStatusSection from "./sections/PropertyStatusSection";
import PaymentTermsSection from "./sections/PaymentTermsSection";
import BillingOptionsSection from "./sections/BillingOptionsSection";
import FeaturesSection from "./sections/FeaturesSection";
import { useFormTouchDetection } from "@/hooks/useFormTouchDetection";

interface PropertyDetailsStepProps {
  form: UseFormReturn<ListingFormValues>;
}

const PropertyDetailsStep = ({ form }: PropertyDetailsStepProps) => {
  // Use the custom hook to handle form touch detection
  useFormTouchDetection('.property-details-form');
  
  return (
    <div className="space-y-6 property-details-form">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building className="h-5 w-5 text-propertylk-blue" />
            Property Details
          </CardTitle>
          <CardDescription>Enter the specifications of your property</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <PlotDetailsSection form={form} />
          <RoomsSection form={form} />
          <PropertyStatusSection form={form} />
          <PaymentTermsSection form={form} />
          <BillingOptionsSection form={form} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Home className="h-5 w-5 text-propertylk-blue" />
            Property Features
          </CardTitle>
          <CardDescription>Select the amenities and features available at your property</CardDescription>
        </CardHeader>
        <CardContent>
          <FeaturesSection form={form} />
        </CardContent>
      </Card>
    </div>
  );
};

export default PropertyDetailsStep;
